import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { init, miniApp, swipeBehavior, viewport } from '@tma.js/sdk';

const initializeTelegramSDK = async () => {
  try {
    await init();

    if (miniApp.ready.isAvailable()) {
      await miniApp.ready();
      console.log('Mini App готово');
    };
    
    if (swipeBehavior.isVerticalEnabled()) {
      swipeBehavior.mount();
      swipeBehavior.disableVertical();
    };
    
    await viewport.mount();
    if (viewport.bindCssVars.isAvailable()) {
      viewport.bindCssVars();
    };
    
  } catch (error) {
    console.error('Ошибка инициализации:', error);
  };
};

initializeTelegramSDK();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);